import React from 'react';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import { ResourceType } from '../../../../types/resource';
import SellerCard from '../../../../SellerCard';
import s from './ShopBlock.scss';
// 308 (sidebar width - padding) - 2 (borders) = 306
const CARD_WIDTH = 306;
const ShopBlock = ({ user, deviations, link })=>{
    return /*#__PURE__*/ React.createElement(BiLoggerContextProvider, {
        value: {
            sectionid: user.userId,
            section_typeid: ResourceType.USER
        }
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['root']
    }, /*#__PURE__*/ React.createElement(SellerCard, {
        width: CARD_WIDTH,
        multiArt: true,
        user: user,
        deviations: deviations,
        link: link,
        withShopCta: true
    })));
};
ShopBlock.displayName = 'ShopBlock';
export default ShopBlock;

//# sourceMappingURL=ShopBlock.js.map